import { useEnvContext } from "context/EnvContext";
import { ENV_DEVELOPMENT, ENV_STAGING } from "core/model/config";
import { isStoryshots } from "core/model/utils/featureFlags";

export default function useShow() {
  const { env } = useEnvContext();
  return !isStoryshots && (env === ENV_DEVELOPMENT || env === ENV_STAGING);
}
